import { createRouter, createWebHistory } from "vue-router";

import VigicoChildren from "./vigico/childrens";

import { useAuth, useOidcStore } from "vue3-oidc";
import { useUserStore } from "@/store/useUserStore";
import { computeRole, UserRole } from "@/composables/useUserRole";

const OidcCallback = () => import("@/components/OidcCallback.vue");
const Vigico = () => import("@/components/Vigico.vue");
const NoAccess = () => import("@/components/NoAccess.vue");

const { autoAuthenticate, setRedirectUri } = useAuth();
const oidcStore = useOidcStore();

const routes = [
  {
    path: "/",
    component: Vigico,
    children: VigicoChildren,
  },
  {
    path: "/no-access",
    name: "no-access",
    component: NoAccess,
  },
  {
    path: "/oidc-callback",
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.isPublic) {
    next();
    return;
  }

  const user = oidcStore.state.value.user;
  const isExpired = oidcStore.state.value.hasExpiresAt;

   if (isExpired) {
    try {
      await oidcStore.state.value.userManager
        ?.signinSilent()
        .then((user) => oidcStore.actions.value.setUser(user));
      if (!oidcStore.state.value.hasExpiresAt) {
        next();
        return;
      }
    } catch (err) {
      console.warn("Silent renew failed, redirecting to login...", err);
    }
  }

  if (!user || isExpired) {
    setRedirectUri(to.fullPath);
    try {
      await autoAuthenticate(to.fullPath);
    } catch (err) {
      console.error("Auto-authenticate error:", err);
    }
  }
  const userStore = useUserStore();
  if (!userStore.uuid) {
    await userStore.loadCurrentUser();
  }

  const role = computeRole(userStore);

  if (role === UserRole.NO_ACCESS && to.name !== "no-access") {
    next({ name: "no-access" });
    return;
  }

  if (to.meta.requiresFullAccess && role !== UserRole.FULL_ACCESS) {
    next({ name: "no-access" });
    return;
  }

  next();
});

export default router;
